import React from 'react'
import styled from '@emotion/styled'
import { loadFromLocalStorage } from '../../store'

const Container = styled.a`
  color: rgba(0, 0, 0, 0.87);
  font-weight: bold;
`

const DownloadLS = () => {
  var dataStr =
    'data:text/json;charset=utf-8,' +
    encodeURIComponent(JSON.stringify(loadFromLocalStorage()))

  return (
    <>
      <Container href={dataStr} download="LocalStorage.json">
        Download LocalStorage
      </Container>
    </>
  )
}

export default DownloadLS
